import type { Dictionary } from '@/i18n/dictionary';
import { ordinal } from '@/lib/format';
import { navKeys } from './site';

export type NavItem = {
  key: string;
  label: string;
  href: string;
  index: string;
};

export function getNavItems(dictionary: Dictionary): NavItem[] {
  return navKeys.map((key, index) => ({
    key,
    label: dictionary.nav[key],
    href: `#${key}`,
    index: ordinal(index),
  }));
}
